export default {"src":"/_next/static/media/four-art.7876816b.svg","height":70,"width":86,"blurWidth":0,"blurHeight":0};